export const addJob       = (payload) => ({ payload, type: 'JOB_ADD' });
export const jobProgress  = (payload) => ({ payload, type: 'JOB_PROGRESS' });
export const jobCompleted = (payload) => ({ payload, type: 'JOB_COMPLETED' });
export const jobFailed    = (payload) => ({ payload, type: 'JOB_FAILED' });
export const jobCancelled = (payload) => ({ payload, type: 'JOB_CANCELLED' });
export const jobStatus    = (payload) => ({ payload, type: 'JOB_STATUS' });
export const dismissJob   = (payload) => ({ payload, type: 'JOB_DISMISS' });
